var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToggleField(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#595959",
    d: "M2.638.534c-.58 0-1.105.237-1.486.618-.381.38-.618.906-.618 1.486s.235 1.106.617 1.487c.38.38.905.617 1.487.617.58 0 1.106-.236 1.487-.617.38-.38.617-.907.617-1.487 0-.58-.237-1.105-.618-1.486S3.217.534 2.638.534z",
    transform: "translate(-153 -695) translate(121 684) translate(32 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M2.644 3.666c-.568 0-1.028-.46-1.028-1.028 0-.568.46-1.028 1.028-1.028.569 0 1.028.46 1.028 1.028 0 .568-.46 1.028-1.028 1.028",
    transform: "translate(-153 -695) translate(121 684) translate(32 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.628 3.234L13.966 3.234",
    transform: "translate(-153 -695) translate(121 684) translate(32 11)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#595959",
    d: "M2.638 8.5c-.58 0-1.105.237-1.486.618-.381.38-.618.907-.618 1.486 0 .58.235 1.106.617 1.488.38.38.905.616 1.487.616.58 0 1.106-.236 1.487-.616.38-.382.617-.908.617-1.488s-.237-1.105-.618-1.486S3.217 8.5 2.638 8.5z",
    transform: "translate(-153 -695) translate(121 684) translate(32 11)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 3.234L14 3.234",
    transform: "translate(-153 -695) translate(121 684) translate(32 11)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0.464L7 0.464",
    transform: "translate(-153 -695) translate(121 684) translate(32 11) translate(7 10.536)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0.464L7 0.464",
    transform: "translate(-153 -695) translate(121 684) translate(32 11) translate(7 10.536)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleField);
export default __webpack_public_path__ + "static/media/toggle-field.c6805131.svg";
export { ForwardRef as ReactComponent };